import { render, staticRenderFns } from "./viewReview.vue?vue&type=template&id=bc2d4708&scoped=true&"
import script from "./viewReview.vue?vue&type=script&lang=js&"
export * from "./viewReview.vue?vue&type=script&lang=js&"
import style0 from "./viewReview.vue?vue&type=style&index=0&id=bc2d4708&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2d4708",
  null
  
)

export default component.exports